module.exports = __webpack_public_path__ + "static/media/911ready.2dc86a49.png";